import { useRemoteConfigBoolean } from "reactfire";
import { createLogger } from "../../utils/logger";

const logger = createLogger("useSettingsSyncEnabled");

export const useSettingsSyncEnabled = () => {
  const { data: settingsSyncEnabled, status } =
    useRemoteConfigBoolean("settingsSyncEnabled");

  if (status === "loading") {
    return false;
  }

  if (status === "error") {
    logger.error("Error fetching remote config for settingsSyncEnabled");
    return false;
  }

  return settingsSyncEnabled;
};
